import React from "react";

const TYPE_LABEL = {
  REGULARISATION: "Regularisation",
  MISSING_OUT:    "Missing Out",
  OVERTIME:       "Overtime",
};

export default function ExceptionsQueue({ loading, items, onApprove, onReject }) {
  if (loading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="h-16 rounded-xl border border-[#00ff90]/20 bg-[#0d0d0d] animate-pulse" />
        ))}
      </div>
    );
  }

  if (!items?.length) {
    return <p className="text-white/30 text-sm py-4 text-center italic">No pending exceptions.</p>;
  }

  return (
    <div className="space-y-2">
      {items.map(x => {
        const isPending = x.status === "PENDING";
        return (
          <div key={x.id}
            className="rounded-xl border border-[#00ff90]/20 bg-[#0d0d0d] p-4 flex items-start justify-between gap-4">
            <div className="min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-sm font-medium text-white">{x.name}</span>
                <span className="text-xs text-white/30">{x.date}</span>
                <span className="text-xs px-2 py-0.5 rounded-full border border-[#00ff90]/20 bg-[#00ff90]/5 text-[#00ff90]/60">
                  {TYPE_LABEL[x.type] || x.type}
                </span>
              </div>
              <p className="text-xs text-white/40 mt-1">
                {x.type === "REGULARISATION" && `${x.payload?.in} → ${x.payload?.req_in} · ${x.payload?.reason}`}
                {x.type === "MISSING_OUT"    && `Set OUT → ${x.payload?.req_out || "—"}`}
                {x.type === "OVERTIME"       && `${x.payload?.minutes} min overtime`}
              </p>
            </div>

            {isPending ? (
              <div className="flex gap-2 shrink-0">
                <button onClick={() => onApprove?.(x.id)}
                  className="text-xs px-3 py-1.5 rounded-lg border border-[#00ff90]/30 bg-[#00ff90]/10 text-[#00ff90] hover:bg-[#00ff90]/20 transition-colors">
                  Approve
                </button>
                <button onClick={() => onReject?.(x.id)}
                  className="text-xs px-3 py-1.5 rounded-lg border border-red-500/30 bg-red-500/10 text-red-400 hover:bg-red-500/20 transition-colors">
                  Reject
                </button>
              </div>
            ) : (
              <span className={`text-xs px-2 py-1 rounded-full border shrink-0 ${
                x.status === "APPROVED" ? "border-[#00ff90]/20 text-[#00ff90]/60 bg-[#00ff90]/5" : "border-red-500/20 text-red-400/60 bg-red-500/5"
              }`}>{x.status}</span>
            )}
          </div>
        );
      })}
    </div>
  );
}